import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-confirm-alert',
  standalone: true,
  imports: [],
  templateUrl: './confirm-alert.component.html',
  styleUrl: './confirm-alert.component.scss'
})
export class ConfirmAlertComponent implements OnInit, OnChanges {

 
  @ViewChild('alertConfirmToast') alertToast: any;
 
  @Input() public showConfirmationModal: boolean = false;
  @Input() public confirmationMessage: string = '';

  @Output() modalConfirm = new EventEmitter<string>(true);
  @Output() modalCancel = new EventEmitter<string>(true);

  constructor() {
 
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showConfirmationModal'] && changes['showConfirmationModal']?.previousValue != changes['showConfirmationModal']?.currentValue) {
     
      if(changes['showConfirmationModal']?.currentValue)
        this.alertToast.nativeElement.classList.add('show');
    }
  }

 
  modalClose() {
    if(this.modalCancel)
      this.modalCancel.emit();
  }

  modalConfirmEvt() {
    if(this.modalConfirm)
      this.modalConfirm.emit();
  }
 
}